import base from "./base.json";
import bottleInventory from "./bottle-inventory.json";
import deliveryAddresses from "./delivery-addresses.json";
import favorites from "./favorites.json";
import orders from "./orders.json";
import product from "./product.json";
import quickOrder from "./quick-order.json";
import refrigerantManagement from "./refrigerant-management.json";
import returnGas from "./return.json";
import start from "./start.json";

const fbsHub = {
  ...base,
  ...bottleInventory,
  ...deliveryAddresses,
  ...favorites,
  ...orders,
  ...product,
  ...quickOrder,
  ...refrigerantManagement,
  ...returnGas,
  ...start,
};

export default fbsHub;
